// scss
import './src/styles/index.scss';

import { ActionContextProvider, createConfig } from './src/cra';

import React from 'react';
import { posthog } from 'posthog-js';

export const onClientEntry = () => {
  const hash = window.location.hash.replace('#', '');
  const params = new URLSearchParams(hash);
  const distinctID = params.get('distinct_id');
  const sessionID = params.get('session_id');

  const initOptions = {
    api_host: process.env.GATSBY_POSTHOG_HOST,
    capture_pageview: false,
  };

  if (distinctID) {
    initOptions.bootstrap = { distinctID, sessionID };
  }

  posthog.init(process.env.GATSBY_POSTHOG_API_KEY, initOptions);
};

export const onRouteUpdate = () => {
  posthog.capture('$pageview');
};

export const wrapRootElement = ({ element }) => {
  createConfig({
    website: 'Life Compared',
  });
  return <ActionContextProvider>{element}</ActionContextProvider>;
};
